import React, { useEffect, useState } from "react";
import Footer from "../component/Footer";
import Header2 from "../component/Header2";
import { Helmet } from "react-helmet";
import axios from "axios";
import { Link, redirect } from "react-router-dom";
import { toast } from "react-toastify";

function Services() {
  // useEffect(()=>{
  //   setTimeout(() => {
  //     setLoading(false)
  //   }, 4000);
  // })
  //   const [loading , setLoading] = useState(true)
  // if(loading)
  //   {
  //     return <center style={{marginTop : "60vh"}}><div class="spinner-grow text-primary" role="status">
  //     <span class="sr-only">Loading...</span>
  //   </div>
  //   <div class="spinner-grow text-secondary" role="status">
  // <span class="sr-only">Loading...</span>
  // </div>
  //   </center>
  //   }

  useEffect(() => {
    fetch();
  }, []);
  const [data, setData] = useState([]);
  const fetch = async () => {
    const res = await axios.get(`https://www.rajvicosmeticclinic.com/RajviApi/categories_get`);
    //console.log(res.data);
    setData(res.data);
  };


  const [cate_id, setcate_id] = useState('');
  const [service_id, setservice_id] = useState('');
  const [app_Date, setapp_Date] = useState('');

  const [data1, setData1] = useState([]);
  const changecategories = async (e) => {
    setcate_id(e.target.value);
    const res = await axios.get(
      `https://www.rajvicosmeticclinic.com/RajviApi/services_single_get_arr?id=${e.target.value}`
    );
    console.log(res.data)
    setData1(res.data);
  };

  function validation() {
    var ans = true;
    if (cate_id == "") {
      toast.error("Categories Field is required");
      ans = false;
      return false;
    }
    if (service_id == "") {
      toast.error(" Services Field is required");
      ans = false;
      return false;
    }
    if (app_Date == "") {
      toast.error("Appointment Date is required");
      ans = false;
      return false;
    }
    return ans;
  }

  const submithandle = async (i) => {
    i.preventDefault();
    if (validation()) {

      const formData = new FormData();
      formData.append('id', new Date().getTime().toString());
      formData.append('service_id', service_id);
      formData.append('userid', localStorage.getItem('userid'));
      formData.append('app_Date', app_Date);
      formData.append('status', 'Pending');

      if (localStorage.getItem("userid")) {
        const res = await axios.post(`https://www.rajvicosmeticclinic.com/RajviApi/appointment_post`, formData);
        console.log(res);
        if (res.status == 200) {
          toast.success(res.data.message);
          redirect('/');
        }
      }
      else {
        toast.warning("Please Login First Now");
        return false;
      }
    }

  };
  return (
    <>
      <Header2 title="Book Services" />
      <div>
        <div className="container-fluid px-0 py-5 my-5">
          <div className="row mx-0 justify-content-center text-center">
            <div className="col-lg-6">
              <h6 className="d-inline-block bg-light text-primary text-uppercase py-1 px-2">
                Our Service
              </h6>
              <h1>Hair &amp; Skin Services</h1>
            </div>
          </div>
          <div className="owl-carousel service-carousel">
            {data &&
              data.map((value, index) => {
                return (
                  <div key={index} className="service-item position-relative">
                    {
                      //`https://www.rajvicosmeticclinic.com/RajviApi/upload/categories/${cate_img}`
                    }
                    <img className="img-fluid" src="/img/service-1.jpg" alt />
                    <div className="service-text text-center">
                      <h4 className="text-white font-weight-medium px-3 mb-3">
                        {value.cate_name}
                      </h4>

                      <div className="w-100 bg-white text-center p-4">
                        <Link to={"/services_details/" + value.id} className="btn btn-primary" >
                          More Service
                        </Link>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>

          <div className="row justify-content-center bg-appointment mx-0">
            <div className="col-lg-6 py-5">
              <div
                className="p-5 my-5"
                style={{ background: "rgba(33, 30, 28, 0.7)" }}
              >
                <h1 className="text-white text-center mb-4">
                  Make Appointment
                </h1>
                <form
                  action=""
                  role="form"
                  method="post"
                  onSubmit={submithandle}
                >
                  <div className="form-row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label htmlFor="">Select Categories</label>
                        <select
                          onChange={(e) => changecategories(e)}
                          name="cate_id"
                          className="form-control bg-transparent p-4"
                        >
                          <option value="">Select Categories</option>
                          {data && data.map((value) => {
                            console.log(value.cate_name);
                            return (
                              <option value={value.id}>
                                {value.cate_name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label htmlFor="">Select services</label>
                        <select
                          onChange={(e) => setservice_id(e.target.value)}
                          name="service_id"
                          className="form-control bg-transparent p-4"
                        >
                          <option value="" >Select services</option>
                          {
                            data1 && data1.map((value) => {
                              return (
                                <option value={value.id}>
                                  {value.service_name}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label htmlFor="">Select Date</label>

                        <input
                          type="date"
                          onChange={(e) => setapp_Date(e.target.value)}
                          name="app_Date"
                          className="form-control bg-transparent p-4 datetimepicker-input"
                          placeholder="Select Date"
                          min=""
                        />
                        <div
                          className="date"
                          id="date"
                          name="app_Date"
                          data-target-input="nearest"
                        >
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <button
                        className="btn btn-primary btn-block"
                        type="submit"
                        style={{ height: 47 }}
                      >
                        Make Appointment
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* Service End */}
        {/* Testimonial Start */}
        <div className="container-fluid py-5">
          <div className="container py-5">
            <div className="row align-items-center">
              <div className="col-lg-6 pb-5 pb-lg-0">
                <img
                  className="img-fluid w-100"
                  src="/img/testimonial.jpg"
                  alt
                />
              </div>
              <div className="col-lg-6">
                <h6 className="d-inline-block text-primary text-uppercase bg-light py-1 px-2">
                  Testimonial
                </h6>
                <h1 className="mb-4">What Our Clients Say!</h1>
                <div className="owl-carousel testimonial-carousel">
                  <div className="position-relative">
                    <i
                      className="fa fa-3x fa-quote-right text-primary position-absolute"
                      style={{ top: "-6px", right: 0 }}
                    />
                    <div className="d-flex align-items-center mb-3">
                      <img
                        className="img-fluid rounded-circle"
                        src="/img/testimonial-1.jpg"
                        style={{ width: 60, height: 60 }}
                        alt
                      />
                      <div className="ml-3">
                        <h6 className="text-uppercase">Client Name</h6>
                        <span>Profession</span>
                      </div>
                    </div>
                    <p className="m-0">
                      Aliquyam sed elitr elitr erat sed diam ipsum eirmod eos
                      lorem nonumy. Tempor sea ipsum diam sed clita dolore eos
                      dolores magna erat dolore sed stet justo et dolor.
                    </p>
                  </div>
                  <div className="position-relative">
                    <i
                      className="fa fa-3x fa-quote-right text-primary position-absolute"
                      style={{ top: "-6px", right: 0 }}
                    />
                    <div className="d-flex align-items-center mb-3">
                      <img
                        className="img-fluid rounded-circle"
                        src="/img/testimonial-2.jpg"
                        style={{ width: 60, height: 60 }}
                        alt
                      />
                      <div className="ml-3">
                        <h6 className="text-uppercase">Client Name</h6>
                        <span>Profession</span>
                      </div>
                    </div>
                    <p className="m-0">
                      Aliquyam sed elitr elitr erat sed diam ipsum eirmod eos
                      lorem nonumy. Tempor sea ipsum diam sed clita dolore eos
                      dolores magna erat dolore sed stet justo et dolor.
                    </p>
                  </div>
                  <div className="position-relative">
                    <i
                      className="fa fa-3x fa-quote-right text-primary position-absolute"
                      style={{ top: "-6px", right: 0 }}
                    />
                    <div className="d-flex align-items-center mb-3">
                      <img
                        className="img-fluid rounded-circle"
                        src="/img/testimonial-3.jpg"
                        style={{ width: 60, height: 60 }}
                        alt
                      />
                      <div className="ml-3">
                        <h6 className="text-uppercase">Client Name</h6>
                        <span>Profession</span>
                      </div>
                    </div>
                    <p className="m-0">
                      Aliquyam sed elitr elitr erat sed diam ipsum eirmod eos
                      lorem nonumy. Tempor sea ipsum diam sed clita dolore eos
                      dolores magna erat dolore sed stet justo et dolor.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <Helmet>
        <script src="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/js/bootstrap.bundle.min.js"></script>
        <script src="/lib/easing/easing.min.js"></script>
        <script src="/lib/waypoints/waypoints.min.js"></script>
        <script src="/lib/counterup/counterup.min.js"></script>
        <script src="/lib/owlcarousel/owl.carousel.min.js"></script>
        <script src="/lib/tempusdominus/js/moment.min.js"></script>
        <script src="/lib/tempusdominus/js/moment-timezone.min.js"></script>
        <script src="/lib/tempusdominus/js/tempusdominus-bootstrap-4.min.js"></script>

        <script src="/mail/jqBootstrapValidation.min.js"></script>
        <script src="/mail/contact.js"></script>

        <script src="/js/main.js"></script>
      </Helmet>
    </>
  );
}

export default Services;
